import * as Types from "src/Constants";

export const setCurrentPage = (value: string) => ({ type: Types.SET_CURRENT_PAGE as "SET_CURRENT_PAGE", value });

export const setPreviousPage = (value: string) => ({ type: Types.SET_PREVIOUS_PAGE as "SET_PREVIOUS_PAGE", value });

export const setNotis = (value: number[]) => ({ type: Types.SET_NOTIS, value });

export const setShowOptions = (value: boolean) => ({ type: Types.SET_SHOW_OPTIONS, value });
